export const DAY_07 = 'DAY_07';
export const DAY_14 = 'DAY_14';
export const DAY_21 = 'DAY_21';
export const DAY_30 = 'DAY_30';
export const DAY_60 = 'DAY_60';
export const DAY_90 = 'DAY_90';
export const EMPLOYEE_COUNT = 'EMPLOYEE_COUNT';
export const OVERRIDE_POINTS = 'OVERRIDE_POINTS';
export const MANUAL_AWARD_POINTS = 'MANUAL_AWARD_POINTS';
export const NO_CALL_OFF_POINTS = 'NO_CALL_OFF_POINTS';
export const NO_CALL_OFF_SHIFTS = 'NO_CALL_OFF_SHIFTS';
export const ON_TIME_POINTS = 'ON_TIME_POINTS';
export const PARTICIPATION = 'PARTICIPATION';
export const QUARTERLY = 'QUARTERLY';
export const REWARD_BUDGET = 'REWARD_BUDGET';
export const REWARD_VALUE = 'REWARD_VALUE';
export const SURVEY = 'SURVEY';
export const SHIFTS_PICKED_UP = 'SHIFTS_PICKED_UP';
export const UPDATE_ALL_THE_THINGS = 'UPDATE_ALL_THE_THINGS';

// For local dev
// export const URL_PREFIX = '';
// The location of the UX/UI demo location
export const URL_PREFIX = '/engage/rewards-point-calc';
